<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
	<div class="footer-block">
		<div v-if="languagesSupported.length > 1" class="mt-3">
			<FontAwesomeIcon icon="globe-europe" class="mr-2" />

			<span v-for="language in languagesSupported" :key="language.key">
				<a :href="'/' + language.key" :class="{'language-active': currentLanguage == language.key}" class="language-switch mr-2" @click.stop.prevent="switchLanguage(language.key)">{{ language.name }}</a>
				<wbr>
			</span>
		</div>

		<div v-if="!settings.ui.footerForceBottomOnDesktop" class="mt-3 default-block-text">
			▪&nbsp;<router-link v-if="settings.newsEnabled" :to="{name: 'news', params: {language: currentLanguage}}" class="menu-item">{{ t.mainMenuNews }}</router-link> 
			
			<span v-for="item in menuItems" :key="item.name">
				▪&nbsp;<router-link :to="{name: item.name, params: {language: currentLanguage}}" class="menu-item">{{ item.title }}</router-link>
			</span>
			
			<div v-if="showSocialIcons" class="social-icons mt-3">
				<div v-if="settings.facebookUrl">
					<a :href="settings.facebookUrl" target="_blank">
						<FontAwesomeIcon :icon="['fab', 'facebook-f']" />
					</a>
				</div>
				<div v-if="settings.youtubeUrl">
					<a :href="settings.youtubeUrl" target="_blank">
						<FontAwesomeIcon :icon="['fab', 'youtube']" />
					</a>
				</div>
			</div>
		</div>

		<div v-if="!settings.ui.footerForceBottomOnDesktop && t.copyright" class="mt-3 small">
			{{ t.copyright }}
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue"
import { switchLanguage } from '@/js/classes/translations';
import { useStore } from '@/js/stores/index';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const store = useStore()

const settings = computed(() => store.settings)
const t = computed(() => store.translations)
const currentLanguage = computed(() => store.currentLanguage)
const showSocialIcons = computed(() => store.settings.facebookUrl || store.settings.youtubeUrl)
const languagesSupported = computed(() => store.settings.languagesSupported)
const menuItems = computed(() => store.menuItems)
</script>
